import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Banco } from '../interfaces/banco';
import { Observable, of } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';
import { BancoTagOption } from '../interfaces/banco-tag-option';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BancoService {

  readonly path = '/banco';
  private tagBancoOptions$?: Observable<BancoTagOption[]>;

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }


  create(): Observable<Banco> {
    return this.http.post<Banco>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(banco: Banco): Observable<Banco> {
    return this.http.put<Banco>(`${this.jwtAuthService.apiUrl + this.path}`, banco);
  }

  getBanco(id: number ): Observable<Banco> {
    return this.http.get<Banco>(`${this.jwtAuthService.apiUrl + this.path}/?BancoId=${id}`);
  }

  getBancoPage(page?: number, size?: number): Observable<PageResult<Banco>> {
    return this.http.get<PageResult<Banco>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}`);
  }

  getBancoPageSearch(page?: number, size?: number,  search?: string): Observable<PageResult<Banco>> {
    return this.http.get<PageResult<Banco>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&search=${search}`);
  }

  getTagBancoOptions(forceRefresh = false): Observable<BancoTagOption[]> {
    if (!this.tagBancoOptions$ || forceRefresh) {
      this.tagBancoOptions$ = this.http.get<BancoTagOption[]>(`${this.jwtAuthService.apiUrl + this.path}/tags`).pipe(
        map(options => (options || []).filter(x => !!x?.value)),
        catchError(() => of([])),
        shareReplay(1)
      );
    }
    return this.tagBancoOptions$;
  }

  clearTagBancoOptionsCache(): void {
    this.tagBancoOptions$ = undefined;
  }

  deleteBanco(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

}
